/**
 * List all possible statuses
 */
export enum AsyncServiceRequestStatus {
  open = 'open',
  closed = 'closed',
}
